

import 'bootstrap/dist/css/bootstrap.min.css';
import Email from '../components/UpdateProfile/Email';
import { useProfileUpdateStore } from '../store/useProfileUpdateStore';
import Password from '../components/UpdateProfile/Password';
import { usePlanStore } from '../store/usePlanStore';
import useAuthStore from '../store/useAuthStore';
import { useEffect, useState } from 'react';
import { useSubscriptionStore } from '../store/useSubscriptionStore';
import SubscriptionInfo from '../components/Payment/SubscriptionInfo';
import { useUserStore } from '../store/useUserStore';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useNotificationStore } from "../store/useNotificationStore";
import edit_icon from '../assets/images/edit_icon.svg';
import visa_icon from '../assets/images/visa_icon.png';
import location_dark from '../assets/images/location_dark.png';
import master_icon from '../assets/images/master_icon.png';
import { useSupportStore } from '../store/useSupportStore';
import default150 from '../assets/images/default150.png';
import { getSizedImageUrl } from '../utils/getSizedImageUrl';
import { useNavigate } from 'react-router-dom';
import useSignOut from 'react-auth-kit/hooks/useSignOut';


const MySwal = withReactContent(Swal);

export default function AccountSettings() {

  const {activeSection, setActiveSection } = useProfileUpdateStore();
  const { plans, getPlans } = usePlanStore();
  const { Gsettings,subscription,paymentDetails,blockedUsers, getSettings, getSubscription, blockUserList,handleUnblock ,deletePaymentProfile, updateSubscriptionPaymentProfile,cancelSubscription} = useSubscriptionStore();
  const navigate = useNavigate();
  const signOut = useSignOut();
  const {logout } = useAuthStore();
  const [currentplan, setPlan] = useState(paymentDetails?.plan_id);
  const [showSubscriptionInfo, setSubscriptionInfo] = useState(false);
  const { updateProfile } = useProfileUpdateStore();
  const { user, getUserDetails,deleteUser,loading } = useUserStore();
  const { submitSupport, sploading, sperror, spsuccess } = useSupportStore();
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState('');
  const [avatarMap, setAvatarMap] = useState<Record<string, string>>({});

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
    const handleSubmit = async () => {
    const newErrors: any = {};
    if (!message.trim()) newErrors.message = "Message is required";
    if (message.length > 300) newErrors.message = "Message too long";

     if (!subject.trim()) newErrors.subject = "Subject is required";
    if (subject.length > 100) newErrors.subject = "Subject too long";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    await submitSupport({
      user_id: user?.id,
      email: user?.email,
      subject:subject,
      text: message,
    });

    if (spsuccess) {
      setMessage(""); // clear after success
      setErrors({});
    }
  };
  const {
    settings,
    getNotificationSettings,
    updateNotificationSettings,
  
  } = useNotificationStore();
  const authStore = useAuthStore.getState();
  const userId= authStore.user.id;
  useEffect(() => {
    getSettings();
    if (userId) getNotificationSettings(userId);
  }, [userId]);


  useEffect(() => {
  if (!blockedUsers?.rows?.length) return;

  (async () => {
    const newAvatarMap: Record<string, string> = {};

    for (const block of blockedUsers.rows) {
      const user = block.user;
      if (!user) continue;

      const raw = user.user_photos?.[0]?.picture;
      const fallback = user.pic || default150;

      const resolved = raw
        ? await getSizedImageUrl(raw, "150x150")
        : fallback;

      newAvatarMap[user.id] = resolved || fallback;
    }

    setAvatarMap(newAvatarMap);
  })();
}, [blockedUsers]);


  type NotificationKey =
  | "new_like"
  | "new_match"
  | "new_message"
  | "profile_visible"
  | "meet_me_email"
  | "weekly_matches"
  | "local_events"
  | "upgrades_billing"
  | "marketing"
  | "other_emails";

const settingOptions: { key: NotificationKey; text: string }[] = [
  { key: "new_like", text: "Send me an email when I get a new like." },
  { key: "new_match", text: "Send me an email when I get a new match." },
  { key: "new_message", text: "Send me an email when I get a new message." },
  { key: "profile_visible", text: "Keep your profile visible so you can be noticed." },
  { key: "meet_me_email", text: "Send me an email when someone says yes to me on Meet Me." },
  { key: "weekly_matches", text: "Send me weekly matches." },
  { key: "local_events", text: "Allow emails from local singles events." },
  { key: "upgrades_billing", text: "Send me emails about upgrades and billing." },
  { key: "marketing", text: "Send me communications about marketing and promotions." },
  { key: "other_emails", text: "Send me other emails from slammmm.com (other than those listed above)." },
];

const handleToggle = (key: NotificationKey) => {
  if (!settings || !userId) return;

  const updated = {
    ...settings,
    [key]: !settings[key],
  };
   console.log('updated',updated);
   

  updateNotificationSettings(userId, updated);
};

  const [visibility, setVisibility] = useState(0);

 
  
    // const toggleClass = (val: boolean) =>
    //   `form-check form-switch d-flex justify-content-between align-items-center py-2 ${
    //     val ? 'text-dark' : 'text-muted'
    //   }`;

  


   useEffect(() => {
    blockUserList({ page: 0, limit: 10, id: userId });
  }, [userId, blockUserList]);
  const confirmUnblockUser = (blockId: any, unblockUser: any) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Unblock User?</h3>
          <p>Do you really want to unblock this user?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button
              className="btn btn-success"
              onClick={() => {
                unblockUser(blockId,userId);
                MySwal.close();
              }}
            >
              Yes, Unblock
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: "bg-light p-4 rounded",
        closeButton: "btn-close position-absolute top-0 end-0 m-3",
      },
    });
  };
  const confirmCancelSubscription = (
    subscriptionId: string,
    cancelSubscription: (userId:number, id: string) => void,
    userId: any,
    getUserDetails: (id: number) => void
  ) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Cancel Subscription?</h3>
          <p>Are you sure you want to cancel this subscription?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              No, Keep It
            </button>
            <button
              className="btn btn-danger"
              onClick={async () => {
                await cancelSubscription(userId,subscriptionId);
                getUserDetails(userId);
                MySwal.close();
              }}
            >
              Yes, Cancel
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: "bg-light p-4 rounded",
        closeButton: "btn-close position-absolute top-0 end-0 m-3",
      },
    });
  };
  
  const confirmDeleteCard = (cardId: string, deleteCard: (id: string) => void) => {
    MySwal.fire({
      html: (
        <div className="text-center">
          <h3>Delete Card?</h3>
          <p>Are you sure you want to delete this card?</p>
          <div className="d-flex justify-content-center gap-2">
            <button className="btn btn-secondary" onClick={() => MySwal.close()}>
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={ async () => {
                await deleteCard(cardId);
                
                getUserDetails(userId);
                MySwal.close();
              }}
            >
              Yes, Delete
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: "bg-light p-4 rounded",
        closeButton: "btn-close position-absolute top-0 end-0 m-3",
      },
    });
  };
  
    useEffect(() => {
    if (user?.hide_profile !== undefined) {
      setVisibility(user.hide_profile);
    }
  }, [user?.hide_profile]);

  const toggleVisibility = () => {
    const newState = visibility == 0 ? 1 : 0;

    setVisibility(newState);

    updateProfile(userId, { hide_profile: newState });
  };


  const getTrialInfo = () => {
    if (!paymentDetails?.trial_end) return null;

    const now = new Date();
    const trialEnd = new Date(paymentDetails.trial_end);

    if (now < trialEnd) {
      const diff = Math.ceil((trialEnd.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
      return {
        isTrial: true,
        daysLeft: diff
      };
    }

    return { isTrial: false };
  };


  useEffect(() => {
    getPlans();
    getSubscription(userId);
    
    getUserDetails(userId);
    console.log('subscription',subscription);
   
    
  }, [userId, getPlans]);

  

  useEffect(() => {
    setPlan(paymentDetails?.plan_id);
   
  }, [paymentDetails]);
  useEffect(() => {
 
    getUserDetails(userId);
   
  }, []);


    // Parse the features array from the plan data
    const parseFeatures = (featuresString: string) => {
      try {
        const features = JSON.parse(featuresString);
        return features.map((feature: any, index: number) => (
          <li key={index}>{feature.text.replace('*', '').trim()}</li>
        ));
      } catch (e) {
        console.log(e);
        
        return null;
      }
    };


    const modal = {
      title: 'Are you sure you want to permanently Delete your account?',
      sub: 'Once your account is deleted, all your settings & account information will be deleted',
      sub1: 'NOTE: There will be no refunds for remaining subscription time after deleting account',
      ok: 'YES, PLEASE DELETE MY ACCOUNT',
      cancle: 'NO, DO NOT DELETE MY ACCOUNT',
    };

   const handleDeleteUser = async (id: any) => {
      const res = await deleteUser(id);

      if (res) {
        Swal.fire({
          title: "Deleted!",
          text: "Your account has been removed.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
        logout();
        signOut();
        navigate('/');
      }
    };
   

          const confirmDeleteAccount = (
            userId: string | number,
            handleDeleteUser: (id: any) => void
          ) => {
            MySwal.fire({
              html: (
                <div className="text-center">
                  <h4>{modal.title}</h4>
                  <p className="mt-2">{modal.sub}</p>
                  <p className="text-danger fw-bold">{modal.sub1}</p>

                  <div className="d-flex justify-content-center gap-2 mt-4">
                    <button
                      className="btn btn-secondary"
                      onClick={() => MySwal.close()}
                    >
                      {modal.cancle}
                    </button>

                    <button
                      className="btn btn-danger"
                      onClick={() => {
                        handleDeleteUser(userId);
                        MySwal.close();
                      }}
                    >
                      {modal.ok}
                    </button>
                  </div>
                </div>
              ),
              showConfirmButton: false,
              showCloseButton: true,
              customClass: {
                popup: "bg-light p-4 rounded",
                closeButton: "btn-close position-absolute top-0 end-0 m-3",
              },
            });
          };


    useEffect(() => {
      const hash = window.location.hash;
  
      if (hash === "#subscription") {
        const tabTrigger = document.querySelector('[data-bs-target="#v-pills-subscription"]');
        if (tabTrigger) {
          // Use Bootstrap's Tab API to activate the tab
          const tab = new (window as any).bootstrap.Tab(tabTrigger);
          tab.show();
        }
      }
    }, []);


  return (
    <>
     <section className="py-60 bg-light">
        <div className="container">
            <div className="row g-3">
                <div className="col-lg-12">
                    <div className="section_title">
                        <h2>Account Settings</h2>
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="nav flex-column nav-pills accountSettingsLeftTabs" id="v-pills-tab" role="tablist"
                        aria-orientation="vertical">
                        <button className="nav-link active" id="v-pills-personal-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-personal" type="button" role="tab" aria-controls="v-pills-personal"
                            aria-selected="true">Personal Details <i className="fa-solid fa-chevron-right"></i></button>
                        <button className="nav-link" id="v-pills-subscription-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-subscription" type="button" role="tab"
                            aria-controls="v-pills-subscription" aria-selected="false">Manage Subscription <i
                                className="fa-solid fa-chevron-right"></i></button>
                        <button className="nav-link" id="v-pills-payment-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-payment" type="button" role="tab" aria-controls="v-pills-payment"
                            aria-selected="false">Payment Method <i className="fa-solid fa-chevron-right"></i></button>
                        <button className="nav-link" id="v-pills-visibility-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-visibility" type="button" role="tab"
                            aria-controls="v-pills-visibility" aria-selected="false">Visibility <i
                                className="fa-solid fa-chevron-right"></i></button>
                        <button className="nav-link" id="v-pills-blocked-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-blocked" type="button" role="tab" aria-controls="v-pills-blocked"
                            aria-selected="false">Blocked Profiles <i className="fa-solid fa-chevron-right"></i></button>
                        <button className="nav-link" id="v-pills-notifications-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-notifications" type="button" role="tab"
                            aria-controls="v-pills-notifications" aria-selected="false">Notifications<i
                                className="fa-solid fa-chevron-right"></i></button>
                        <button className="nav-link" id="v-pills-break-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-break" type="button" role="tab" aria-controls="v-pills-break"
                            aria-selected="false">Take a Break<i className="fa-solid fa-chevron-right"></i></button>
                        
                            <button className="nav-link" id="v-pills-delete-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-support" type="button" role="tab" aria-controls="v-pills-support"
                            aria-selected="false">Support<i className="fa-solid fa-chevron-right"></i></button>
                            <button className="nav-link" id="v-pills-delete-tab" data-bs-toggle="pill"
                            data-bs-target="#v-pills-delete" type="button" role="tab" aria-controls="v-pills-delete"
                            aria-selected="false">Delete Account<i className="fa-solid fa-chevron-right"></i></button>
                    </div>
                </div>

                <div className="col-lg-9">

                    <div className="tab-content" id="v-pills-tabContent">
                        <div className="tab-pane fade show active" id="v-pills-personal" role="tabpanel"
                            aria-labelledby="v-pills-personal-tab" tabIndex={0}>
                            <div className="row g-3">
                                <div className={activeSection ? " col-lg-8 " : " col-lg-12 "}>
                                    <div className="card p-lg-4 p-3 border rounded-4">
                                        <div className="accountSettingTitle border-bottom mb-4">
                                            <h4>Manage Personal Details</h4>
                                            <p>Review and update your basic information.</p>
                                        </div>
                                        <div className="account_personaldetails_item">
                                            <h5>Username</h5>
                                            <p>{user?.first_name}</p>

                                        </div>
                                        <div className="account_personaldetails_item">
                                            <h5>Email</h5>
                                            <p>{user?.email}</p>
                                            <button className="btn btn-outline-primary btn_primary_edit" onClick={() => setActiveSection("email")}>
                                                <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                                            </button>
                                        </div>
                                        <div className="account_personaldetails_item">
                                            <h5>Password</h5>
                                            <p>*********</p>
                                            <button className="btn btn-outline-primary btn_primary_edit" onClick={() => setActiveSection("password")}>
                                                <img src={edit_icon} alt="" className="img-fluid edit-icon" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                {activeSection === 'email' && (
                                  <Email />
                                  )}
                                  {activeSection === 'password' && (
                                  <Password />
                                  )}
                               
                            </div>

                        </div>
                        <div className="tab-pane fade" id="v-pills-subscription" role="tabpanel"
                            aria-labelledby="v-pills-subscription-tab" tabIndex={0}>
                             {showSubscriptionInfo ? 
                                <SubscriptionInfo 
                                  savedCards={user?.credit_cards}
                                  settings={Gsettings}
                                  planId={currentplan} 
                                  type="signup"
                                  paymentDetails={paymentDetails}
                                  handleClose={() => setSubscriptionInfo(false)} 
                                />
                              : (
                                <div className="card p-lg-4 p-3 border rounded-4 mb-3">
                                  <div className="accountSettingTitle border-bottom mb-4">
                                    <h4>Manage Subscription</h4>
                                    <p>Choose the subscription plan that suits you best</p>
                                  </div>

                                  <div className="account_subscription_lists">
                                    {plans && plans.map((plan: any) => (
                                      <div key={plan.id} className="account_subscription_plan form-check position-relative">

                                        {paymentDetails?.plan_id == plan.id && (
                                          <div className="account_subscription_plan_badge">Current plan</div>
                                        )}

                                        {plan.title == "Platinum" && (
                                          <div className="account_subscription_plan_badge">Most popular</div>
                                        )}

                                        <label className="form-check-label w-100 mt-4" htmlFor={`plan-${plan.id}`}>
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="subscriptionPlan"
                                            id={`plan-${plan.id}`}
                                            checked={currentplan == plan.id}
                                            onChange={() => setPlan(plan.id)}
                                          />

                                          <div className="d-flex justify-content-between align-items-center mb-3 ps-2">
                                            <h5 className="mb-1">{plan.title}</h5>
                                            {(() => {
                                                const trial = getTrialInfo();

                                                if (paymentDetails?.plan_id == plan.id && trial?.isTrial) {
                                                  return (
                                                    <h5 className="text-success mb-1">
                                                      Free Trial – {trial.daysLeft} day(s) left
                                                    </h5>
                                                  );
                                                }

                                                return (
                                                  <h5 className="text-danger mb-1">
                                                    ${plan.amount} / {plan.interval_count} {plan.interval}(s)
                                                  </h5>
                                                );
                                              })()}
                                          </div>

                                          <ul className="list-unstyled">
                                            {parseFeatures(plan.features)}
                                          </ul>

                                          {paymentDetails?.plan_id == plan.id && plan.id != 4 && paymentDetails?.transaction_id && (
                                            <div className="ps-4">
                                              <button
                                                className="btn btn-outline-danger btn-sm py-2 mt-3"
                                                onClick={() =>
                                                  confirmCancelSubscription(
                                                    paymentDetails.transaction_id,
                                                    cancelSubscription,
                                                    userId,
                                                    getUserDetails
                                                  )
                                                }
                                              >
                                                Cancel Subscription
                                              </button>
                                            </div>
                                          )}
                                        </label>
                                      </div>
                                    ))}

                                    <div className="text-end">
                                      {currentplan == 4 || paymentDetails?.plan_id == currentplan ? (
                                        <button className="btn btn-primary px-lg-5" disabled>Continue</button>
                                      ) : (
                                        <button className="btn btn-primary px-lg-5" onClick={() => setSubscriptionInfo(true)}>Continue</button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              )}


                            
                        </div>
                        <div className="tab-pane fade" id="v-pills-payment" role="tabpanel"
                            aria-labelledby="v-pills-payment-tab" tabIndex={0}>
                              <div className="row">
                              {user?.credit_cards != undefined && user.credit_cards.length > 0 ?
                                <>
                                 <div className={showSubscriptionInfo ? " col-lg-8  rounded" : " col-lg-12  rounded"} >
                                    <div className="card p-lg-4 p-3 border rounded-4 mb-3">
                                        <div className="accountSettingTitle border-bottom mb-4">
                                            <h4>Payment Method</h4>
                                            <p>Update your payment method</p>
                                        </div>
                                        <div className="account_subscription_lists">
                                        {user?.credit_cards != undefined && user.credit_cards.length > 0 ?
                                      <>
                                      {user?.credit_cards?.map((card: any, index: number) => (
                                            <div  key={index} className="account_subscription_plan form-check">
                                              {card.status && (
                                                 <div className="account_subscription_plan_badge">
                                                 Default card
                                             </div>
                                              )}
                                               

                                                <label className="form-check-label w-100 mt-4" htmlFor={`paymentCard1${index}`}>
                                                  
                                                     <input
                                                        className=" form-check-input"
                                                        type="radio"
                                                        name="defaultCard"
                                                         id={`paymentCard1${index}`}
                                                        checked={card.status}
                                                        onChange={() => {
                                                          if (!card.status) {
                                                            MySwal.fire({
                                                              html: (
                                                                <div className="text-center">
                                                                  <h4>Set as Default?</h4>
                                                                  <p>Do you want to make this card your default payment method?</p>
                                                                  <div className="d-flex justify-content-center gap-2">
                                                                    <button
                                                                      className="btn btn-secondary"
                                                                      onClick={() => MySwal.close()}
                                                                    >
                                                                      Cancel
                                                                    </button>
                                                                    <button
                                                                      className="btn btn-primary"
                                                                      onClick={async () => {
                                                                        await updateSubscriptionPaymentProfile(userId, card.card_id);
                                                                        getUserDetails(userId);
                                                                        MySwal.close();
                                                                      }}
                                                                    >
                                                                      Yes, Change
                                                                    </button>
                                                                  </div>
                                                                </div>
                                                              ),
                                                              showConfirmButton: false,
                                                              showCloseButton: true,
                                                              customClass: {
                                                                popup: 'bg-light p-4 rounded',
                                                                closeButton: 'btn-close position-absolute top-0 end-0 m-3',
                                                              },
                                                            });
                                                          }
                                                        }}
                                                      />      
                                                    <div
                                                        className="d-flex align-items-center justify-content-between mb-3 ">
                                                        <div className="ps-4">
                                                            <h5 className="mb-2">{card.card_name}</h5>
                                                            <p className="mb-0">{card.card_number ?? '------'}</p>
                                                        </div>
                                                        <div className="">
                                                          {card.card_type=='Visa'? 
                                                            <img src={visa_icon} alt="" />
                                                            :  
                                                            <img src={master_icon} alt="" />
                                                          }
                                                        </div>
                                                    </div>
                                                    <div className="text-end">
                                                        <a href="#" onClick={async () => {
                                                                const userCards = user?.credit_cards || [];
                                                                const isOnlyCard = userCards.length === 1;
                                                                const hasSubscription = !!subscription; // Assuming you have subscription in state

                                                                if (isOnlyCard && hasSubscription) {
                                                                  MySwal.fire({
                                                                    icon: 'warning',
                                                                    title: 'Cannot delete card',
                                                                    text: 'You cannot delete your only card while you have an active subscription. Please add another card first.',
                                                                    confirmButtonText: 'OK',
                                                                  });
                                                                } else {
                                                                  confirmDeleteCard(card.card_id, (id) => {
                                                                    deletePaymentProfile(userId, id);
                                                                  });
                                                                }
                                                              }} className="text-decoration-none font400"><i
                                                                className="fa-regular fa-trash-can me-2 text-primary"></i>
                                                            Delete
                                                            Card</a>
                                                    </div>

                                                </label>
                                            </div>
                                          ))}

                                            </>
                                            :''}

                                           

                                            <div className="text-end">
                                                <a href="#" onClick={()=>setSubscriptionInfo(true)} className="text-decoration-none font400  text-primary"><i
                                                        className="fa-solid fa-plus me-2"></i>
                                                    Add Payment Methord</a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                {showSubscriptionInfo ? 
                                        <SubscriptionInfo 
                                        savedCards={user?.credit_cards}
                                        settings={Gsettings}
                                        planId={currentplan} 
                                        type="add_new_card"
                                        paymentDetails={paymentDetails}
                                        handleClose={() => setSubscriptionInfo(false)}  />
                                        :''}
                                </div>
                                
                                </>
                                :
                                      <SubscriptionInfo 
                                        savedCards={user?.credit_cards}
                                        settings={Gsettings}
                                        planId={currentplan} 
                                        type="add_new_card"
                                        colum='col-md-4'
                                        paymentDetails={paymentDetails}
                                        handleClose={() => setSubscriptionInfo(false)}  />
                                }


                               
                            </div>



                             
                            
                            
                          </div>
                        <div className="tab-pane fade" id="v-pills-visibility" role="tabpanel"
                            aria-labelledby="v-pills-visibility-tab" tabIndex={0}>
                              <div className="card p-lg-4 p-3 border rounded-4">
                                <div className="accountSettingTitle border-bottom mb-4 pb-2">
                                    <h4>Your Profile is Visible</h4>
                                </div>
                                <div className="row gx-lg-5">
                                    <div className="col-md-7">
                                        <div className="account_subscription_lists">
                                            <div className="account_subscription_plan form-check p-0">

                                                <label className="form-check-label w-100 p-3" htmlFor="visibility1">
                                                    <input className=" form-check-input" type="radio" name="visibilityItem"
                                                        id="visibility1"  checked={visibility==0 ? true : false}
                                                        onChange={toggleVisibility} />
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className="ps-4">
                                                            <h5 className="mb-2">Visible - Anyone can see you </h5>
                                                            <p className="mb-0">Keep your profile visible so you can be
                                                                noticed.</p>
                                                        </div>
                                                    </div>


                                                </label>
                                            </div>

                                            <div className="account_subscription_plan form-check p-0">
                                                <label className="form-check-label w-100 p-3" htmlFor="visibility2">
                                                    <input className=" form-check-input" type="radio" name="visibilityItem"
                                                        id="visibility2" checked={visibility==1 ? true : false}
                                                        onChange={toggleVisibility} />
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className="ps-4">
                                                            <h5 className="mb-2">Hidden - No one can see you</h5>
                                                            <p className="mb-0">Hiding your profile keeps you from being
                                                                noticed.</p>
                                                        </div>
                                                    </div>

                                                </label>
                                            </div>


                                        </div>
                                    </div>

                                </div>
                            </div>
                             

                            </div>
                        <div className="tab-pane fade" id="v-pills-blocked" role="tabpanel"
                            aria-labelledby="v-pills-blocked-tab" tabIndex={0}>
                                <div className="card p-lg-4 p-3 border rounded-4">
                                <div className="accountSettingTitle border-bottom mb-4 pb-2">
                                    <h4>Blocked Members</h4>
                                </div>
                              {blockedUsers?.rows?.length > 0 ? (
                                  blockedUsers.rows.map((block: any) => {
                                    const user = block.user;
                                    const avatar = avatarMap[user?.id] || default150;

                                    return (
                                      <div
                                        className="d-flex align-items-center account_settings_blocked_items border rounded-4 p-3"
                                        key={block.id}
                                      >
                                        <div className="account_settings_blocked_img_box">
                                          <img
                                            src={avatar}
                                            alt={user?.first_name}
                                            className="img-fluid"
                                          />
                                        </div>
                                        <div className="d-flex flex-sm-row flex-column align-items-sm-center w-100">
                                          <div>
                                            <h4>
                                              {user?.first_name}, {user?.age || ""}
                                            </h4>
                                            <p className="mb-0">
                                              <img src={location_dark} className="me-2" />
                                              {user?.city} {user?.state}
                                            </p>
                                          </div>
                                          <div className="ms-auto me-lg-3">
                                            <a
                                              href="#"
                                              onClick={() => confirmUnblockUser(block.id, handleUnblock)}
                                              className="text-decoration-none font400 text-primary"
                                            >
                                              Unblock
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })
                                ) : (
                                  <p>No blocked users found.</p>
                                )}
                                

                            </div>
                               
                        </div>
                        <div className="tab-pane fade" id="v-pills-notifications" role="tabpanel"
                            aria-labelledby="v-pills-notifications-tab" tabIndex={0}>
                                

                                <div className="card p-lg-4 p-3 border rounded-4">
                                  <div className="accountSettingTitle border-bottom mb-4 pb-2">
                                    <h4>Notification Settings</h4>
                                  </div>

                                  <div className="account_settings_notification_item_list">
                                    {settings ? (
                                      settingOptions.map(({ key, text }, index) => (
                                        <div className="account_settings_notification_item" key={key}>
                                          <label className="form-check-label mb-0" htmlFor={`switch${index}`}>
                                            {text}
                                          </label>
                                          <div className="form-check form-switch m-0">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`switch${index}`}
                                              checked={settings[key]}
                                              onChange={() => handleToggle(key)}
                                            />
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <p>Loading settings...</p>
                                    )}
                                  </div>
                                </div>

                        </div>
                        <div className="tab-pane fade" id="v-pills-break" role="tabpanel"
                            aria-labelledby="v-pills-break-tab" tabIndex={0}>
                              <div className="card p-lg-4 p-3 border rounded-4">
                              <div className="accountSettingTitle border-bottom mb-4 pb-2">
                                <h4>Take a break?</h4>
                              </div>
                              <div className="row align-items-center">
                                <div className="col-sm-10">
                                  <label className="form-check-label mb-0 font18" htmlFor="switch_take_a_break">
                                    You will no longer be suggested to new users on Dating. However, you can
                                    still respond to people who have already liked or matched with you.
                                  </label>
                                </div>
                                <div className="col-sm-2 justify-content-sm-end d-flex">
                                  <div className="form-check form-switch m-0">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="switch_take_a_break"
                                      checked={visibility==0 ? false : true}
                                      onChange={toggleVisibility}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>


                            </div>
                        <div className="tab-pane fade" id="v-pills-delete" role="tabpanel"
                            aria-labelledby="v-pills-delete-tab" tabIndex={0}>
                               <div className="card p-lg-4 p-3 border rounded-4">
                                <div className="accountSettingTitle border-bottom mb-4 pb-2">
                                    <h4>Delete Account</h4>
                                </div>
                                <div className="">
                                    <p>Are you sure want to delete this account ?</p>
                                    <button
                                  className="btn btn-primary"
                                  onClick={() => confirmDeleteAccount(user?.id, handleDeleteUser)}
                                  disabled={loading}
                                >
                                  {loading ? "Deleting..." : "Delete Account"}
                                </button>
                           
                                </div>



                            </div>
                             


                            </div>

                            <div className="tab-pane fade" id="v-pills-support" role="tabpanel" aria-labelledby="v-pills-support-tab" tabIndex={0}>
                                <div className="card p-lg-4 p-3 border rounded-4">
                                  <div className="accountSettingTitle border-bottom mb-4 pb-2">
                                    <h4>Supports</h4>
                                  </div>

                                  <div className="form_group">
                                    <label className="form-label w-100"></label>
                                    <div className="row">
                                      <div className="col-md-12">

                                        {/* ✅ Subject Field */}
                                        <div className="">
                                        
                                          <input
                                            type="text"
                                            className="form-control rounded-3"
                                            placeholder="Subject"
                                            maxLength={100}
                                            value={subject}
                                            onChange={(e) => setSubject(e.target.value)}
                                          />
                                          <div className="d-flex justify-content-between">
                                          <p className="text-red-500 text-sm">
                                            {errors["subject"] && <>{errors["subject"]}</>}
                                            {sperror && <>{sperror}</>}
                                          </p>
                                          <div className={`float-right text-end text-sm mt-1 ${subject.length > 100 ? 'text-red-500' : 'text-muted'}`}>
                                            {subject.length}/100
                                          </div>
                                        </div>
                                          
                                        </div>

                                        {/* ✅ Message Field */}
                                        <textarea
                                          className="form-control rounded-3 mt-2"
                                          rows={5}
                                          placeholder="Your message"
                                          maxLength={300}
                                          value={message}
                                          onChange={(e) => setMessage(e.target.value)}
                                        />
                                        <div className="d-flex justify-content-between">
                                          <p className="text-red-500 text-sm">
                                            {errors["message"] && <>{errors["message"]}</>}
                                            {sperror && <>{sperror}</>}
                                          </p>
                                          <div className={`float-right text-end text-sm mt-1 ${message.length > 300 ? 'text-red-500' : 'text-muted'}`}>
                                            {message.length}/300
                                          </div>
                                        </div>

                                        <button
                                          onClick={handleSubmit}
                                          className="btn btn-primary mt-3"
                                          disabled={sploading}
                                        >
                                          {sploading ? "Sending..." : "Send Support Message"}
                                        </button>

                                        {spsuccess && <p className="text-success mt-2">Message sent successfully!</p>}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                    </div>

                </div>

            </div>

        </div>
    </section>
  
    </>
  );
}
